import { render, staticRenderFns } from "./DialogElectricalDrawing.vue?vue&type=template&id=585d98f6&"
import script from "./DialogElectricalDrawing.vue?vue&type=script&lang=js&"
export * from "./DialogElectricalDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports